import axios from 'axios';
import { get as _get } from 'lodash';
import { appDefIds, getCurrentInstance } from '@wix/business-manager-api';

export const get = ({ apiBaseUrl, instance }) => async ({ path }) =>
  axios
    .get(`${apiBaseUrl}${path}`, { headers: getInstanceHeaders(instance) })
    .then(({ data }) => data);

export const del = ({ apiBaseUrl, instance }) => async ({ path }) =>
  axios
    .delete(`${apiBaseUrl}${path}`, { headers: getInstanceHeaders(instance) })
    .then(({ data }) => data);

export const post = ({ apiBaseUrl, instance }) => async ({ path, params }) =>
  axios
    .post(`${apiBaseUrl}${path}`, params, {
      headers: getInstanceHeaders(instance),
    })
    .then(({ data }) => data);

function getInstanceHeaders(instance) {
  instance = instance || getCurrentInstance(appDefIds.marketingIntegration);
  return {
    instance,
    Authorization: instance,
  };
}

export const isPartner = async ({ userId, metaSiteId }) => {
  const userGroupsField = 'user_groups';
  const userBiPofileFields = await fetchBiProfile({
    userId,
    metaSiteId,
    fields: [userGroupsField],
  });
  return (
    userBiPofileFields &&
    _get(userBiPofileFields, 'fields.user_groups.manyValues.values', []).some(
      ({ aString = '' }) => aString === 'finished_partner_onboarding',
    )
  );
};

export const fetchBiProfile = async ({ userId, metaSiteId, fields }) => {
  const api = '/_api/wix-bi-profile-webapp/v2';
  const endpoint =
    userId && metaSiteId
      ? `/site/${userId}/${metaSiteId}`
      : userId
      ? `/user/${userId}`
      : '';
  const queryParams = fields.map((field) => `fields=${field}`).join('&');
  const response = await axios.get(`${api}${endpoint}?${queryParams}`);
  return response.data;
};
